import {Injectable} from '@angular/core';
import {MatIconRegistry} from '@angular/material/icon';
import {DomSanitizer} from '@angular/platform-browser';

/**
 * Add all the icons you want to use in the application here. Icons need to be in SVG format and well organized
 * in the /assets folder.
 // 'user-profile-filled': '../assets/icons/user-profile-filled.svg',
 */
const ICONS: { [iconName: string]: string } = {
  'brand-logo': '../assets/brand/brand-logo.svg',
  'brand-icon': '../assets/brand/brand-icon.svg',
  'brand-icon-alt-1': '../assets/brand/brand-icon-alt-1.svg',
  'illustration-person-leaving': '../assets/illustrations/undraw_travel_mode_re_2lxo.svg',
  'illustration-waiting-seasons': '../assets/illustrations/undraw_season_change_f99v.svg',
  'icon-show-password': '../assets/icons/actions/icon-show-password.svg',
  'icon-hide-password': '../assets/icons/actions/icon-hide-password.svg',
};

@Injectable({
  providedIn: 'root'
})
export class CustomIconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
  }

  public loadSvgIcons(icons: string[]): void {
    icons.forEach(iconName => {
      if (ICONS[iconName]) {
        this.matIconRegistry.addSvgIcon(
          iconName,
          this.domSanitizer.bypassSecurityTrustResourceUrl(ICONS[iconName])
        );
      } else {
        console.warn(`Icon with the name '${iconName}' does not exist.`);
      }
    });
  }
}
